export const gtmProductPageInteractionEvent = (
  interactionType: string,
  interactionName: string,
  interactionSelection: string,
) => ({
  event: 'product_page_interaction',
  interaction_type: interactionType,
  interaction_name: interactionName,
  interaction_selection: interactionSelection,
});

export default gtmProductPageInteractionEvent;
